import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';

import { AdminLayoutComponent } from '@theme/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from '@theme/auth-layout/auth-layout.component';
import { LoginComponent } from './sessions/login/login.component';
import { AuthGuard } from '@core';

const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {path: '', redirectTo: 'import', pathMatch: 'full'},
      {path: 'dashboard', redirectTo: 'import', pathMatch: 'full'},
      // {path: 'dashboard', component: DashboardComponent},
      {
        path: 'sessions',
        loadChildren: () => import('./sessions/sessions.module').then(m => m.SessionsModule),
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'user',
        loadChildren: () => import('./user/user.module').then(m => m.UserModule)
      },
      {
        path: 'import',
        loadChildren: () => import('./import/import.module').then(m => m.ImportModule)
      },
      {
        path: 'export',
        loadChildren: () => import('./export/export.module').then(m => m.ExportModule)
      },
      {
        path: 'acceptance-report',
        loadChildren: () => import('./acceptance_report/acceptance_report.module').then(m => m.AcceptanceReportModule)
      },
      {
        path: 'stoerungsflaechen-export',
        loadChildren: () => import('./stoerungsflaechen_export/stoerungsflaechen_export.module').then(m => m.StoerungsflaechenExportModule)
      },
      {
        path: 'habitat-export',
        loadChildren: () => import('./habitat_export/habitat_export.module').then(m => m.HabitatExportModule)
      },
      {
        path: 'app',
        loadChildren: () => import('./app/app.module').then(m => m.AppModule)
      },
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {path: 'login', component: LoginComponent},
    ],
  },
  {path: '**', redirectTo: 'dashboard'},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
    }),
  ],
  exports: [RouterModule],
})
export class RoutesRoutingModule {
}
